
import { defineComponent } from "vue";
import AnchorButton from "@/components/AnchorButton.vue";
import amplitude from "amplitude-js";
import * as config from "@/plugins/remote-config";

export default defineComponent({
  name: "App",
  components: {
    AnchorButton
  },
  setup() {
    const deviceId = amplitude.getInstance().options.deviceId;
    const APP_URL =
      process.env.VUE_APP_ENDPOINTS === "production"
        ? `https://samply.app/?deviceid=${deviceId}`
        : `https://staging.samply.app/?deviceid=${deviceId}`;
    amplitude.getInstance().logEvent("[Website] Visited Landing Page");
    amplitude.getInstance().logEvent("[Website] Visited Landing Page");
    return {
      appURL: APP_URL
    };
  },
  methods: {
    onCTA(buttonText: string) {
      amplitude.getInstance().logEvent("[Website] Clicked CTA", { buttonText });
    },
    pricingEvent() {
      amplitude.getInstance().logEvent("[Website] Clicked Pricing");
    }
  },
  computed: {
    loading(): boolean {
      return !config.state.activated;
    }
  }
});
